import React, { useState, useEffect } from "react";
import { Space, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  CheckSquareOutlined,
  DisconnectOutlined,
} from "@ant-design/icons";
import { CopyOutlined } from "@ant-design/icons";

import "./resumeResultsCard.scss";
import AIIcon from "../../assets/aitech.png";
import BooMarkIcon from "../../assets/bookmark.png";
import CheckIcon from "../../assets/checkmark.png";

export default function EvaluationQuestionsCard({
  qhjid,
  ev_id,
  evalDesc,
  localQDesc,
  localQDeleteHandler,
  localQCopyHandler,
  localQEditHandler,
  index,
  selectedQs,
  selectedQHandler,
  localDelinkHandler,
  qbank,
}) {
  const navigate = useNavigate();
  const [toCopy, setCopy] = useState(true);
  const [toDelete, setDelete] = useState(true);
  const [toEdit, setEdit] = useState(true);
  const [toSelect, setSelect] = useState(0);
  const [toDelink, setDelink] = useState(true);

  var localItem = evalDesc.skillarray?.filter(
    (item) =>
      item?.skill.toLowerCase() == localQDesc[index].skill.toLowerCase(),
  );
  useEffect(() => {
    //console.log("Question Number", index, localQDesc[index])
    //console.log("Eval",evalDesc,localQDesc[index].ID)
    var tempQ = evalDesc.evqsetdescarray?.filter(
      (item) =>
        item.questionid == localQDesc[index].ID ||
        item.questionid == localQDesc[index].id,
    );
    if (tempQ?.length > 0) setSelect(2); //set from server cannot change

    if (selectedQs?.length > 0) {
      var tempQ2 = selectedQs?.filter(
        (item) =>
          item.ID == localQDesc[index].ID || item.ID == localQDesc[index].id,
      );
      if (tempQ2?.length > 0) setSelect(1);
    }
  }, []);

  const handleAIIcon = () => {};

  const handleRemove = (indexToRemove) => {
    //now update the current list
    var selectedQsNew = selectedQs.filter(
      (item) => item.ID !== localQDesc[indexToRemove].ID,
    );
    if (selectedQsNew != null) {
      selectedQHandler([...selectedQsNew]);
    } else {
      selectedQHandler([]);
    }
  };

  const handleSelectedQ = (ev, index) => {
    if (toSelect == 0) {
      console.log("flag", 1, index);
      setSelect(1);
      selectedQs?.push(localQDesc[index]);
      selectedQHandler([...selectedQs]);
    } else if (toSelect == 1) {
      console.log("flag", 0, index);
      setSelect(0);
      handleRemove(index);
    }
  };

  const isMultipleChoice = () => {
    if (
      localQDesc[index].questiontype == "Multiple Choice" ||
      localQDesc[index].questiontype == "Multiple Choice Code"
    ) {
      return true;
    }
    return false;
  };
  return (
    <div className="evalQuestionsCard-wrapper">
      <div className="resumeResultsCard-name">
        {localQDesc[index].ID != null ? (
          <>
            <div className="resumeResultsCard-name-icon">
              <img
                src={BooMarkIcon}
                alt="BookMark"
                width="14"
                height="14"
                className="image"
                onClick={handleAIIcon}
              />
            </div>
          </>
        ) : (
          <></>
        )}
        {localQDesc[index].source == "Custom" ? (
          <></>
        ) : (
          <>
            <div className="resumeResultsCard-name-icon">
              <img
                src={AIIcon}
                alt="AI"
                width="14"
                height="14"
                className="image"
                onClick={handleAIIcon}
              />
            </div>
          </>
        )}
        <div className="resumeResultsCard-name-row">
          {localQDesc[index].questionid}
        </div>
        <div className="resumeResultsCard-name-row">
          {localQDesc[index].questiontype}
        </div>
        <div className="resumeResultsCard-name-row">
          {localQDesc[index].assessmenttype}
        </div>
        <div className="resumeResultsCard-name-row">
          {localItem?.[0]?.weightage == 1 ? "Mandatory" : "Optional"}
        </div>
        <div className="resumeResultsCard-name-row">
          {localQDesc[index].skill.toUpperCase()}
        </div>
      </div>
      <div className="resumeResultsCard-heading">
        Q {index + 1} {localQDesc[index].question}
      </div>
      {localQDesc[index].questiontype == "Multiple Choice Code" ? (
        <>
          <div className="resumeResultsCard-skills">
            {localQDesc[index].multiplechoicecode}
          </div>
        </>
      ) : (
        <></>
      )}
      {isMultipleChoice() ? (
        <>
          <div className="resumeResultsCard-current">
            <div className="resumeResultsCard-current-row">
              <div className="resumeResultsCard-current-column">1</div>
              <div className="resumeResultsCard-current-column">
                {localQDesc[index].optiona}
              </div>
              <div className="resumeResultsCard-current-column">2</div>
              <div className="resumeResultsCard-current-column">
                {localQDesc[index].optionb}
              </div>
              <div className="resumeResultsCard-current-column">3</div>
              <div className="resumeResultsCard-current-column">
                {localQDesc[index].optionc}
              </div>
              <div className="resumeResultsCard-current-column">4</div>
              <div className="resumeResultsCard-current-column">
                {localQDesc[index].optiond}
              </div>
            </div>
          </div>
          <div className="resumeResultsCard-heading">Answer: </div>
          <div className="resumeResultsCard-skills">
            {localQDesc[index].answer}
          </div>
        </>
      ) : localQDesc[index].questiontype == "True/False" ? (
        <>
          <div className="resumeResultsCard-current">
            <div className="resumeResultsCard-current-row">
              <div className="resumeResultsCard-current-column">1</div>
              <div className="resumeResultsCard-current-column">True</div>

              <div className="resumeResultsCard-current-column">2</div>
              <div className="resumeResultsCard-current-column">False</div>
            </div>
          </div>
          <div className="resumeResultsCard-heading">Answer: </div>
          <div className="resumeResultsCard-skills">
            {localQDesc[index].answer}
          </div>
        </>
      ) : localQDesc[index].questiontype == "Text Input" ? (
        <>
          <div className="resumeResultsCard-heading">Answer: </div>
          <div className="resumeResultsCard-skills">
            {localQDesc[index].answer}
          </div>
        </>
      ) : localQDesc[index].questiontype == "Coding" ? (
        <>
          <div className="resumeResultsCard-heading">Answer: </div>
          <div className="resumeResultsCard-skills">
            {localQDesc[index].answer}
          </div>
        </>
      ) : (
        <></>
      )}
      <div className="resumeResultsCard-othes">
        {qbank ? (
          <>
            <div className="resumeResultsCard-Icons">
              <Space onClick={(ev) => localQDeleteHandler(ev, index)}>
                <Tooltip
                  placement="bottom"
                  title={"Delete"}
                  color="white"
                  overlayInnerStyle={{
                    color: "#000",
                  }}
                >
                  {toDelete ? (
                    <DeleteOutlined style={{ cursor: "pointer" }} />
                  ) : (
                    <></>
                  )}
                </Tooltip>
              </Space>
            </div>
            <div className="resumeResultsCard-Icons">
              <Space onClick={(ev) => localQCopyHandler(ev, index)}>
                <Tooltip
                  placement="bottom"
                  title={"Duplicate"}
                  color="white"
                  overlayInnerStyle={{
                    color: "#000",
                  }}
                >
                  {toCopy ? (
                    <CopyOutlined style={{ cursor: "pointer" }} />
                  ) : (
                    <></>
                  )}
                </Tooltip>
              </Space>
            </div>
            <div className="resumeResultsCard-Icons">
              <Space onClick={(ev) => localQEditHandler(ev, index)}>
                <Tooltip
                  placement="bottom"
                  title={"Edit"}
                  color="white"
                  overlayInnerStyle={{
                    color: "#000",
                  }}
                >
                  {toEdit ? (
                    <EditOutlined style={{ cursor: "pointer" }} />
                  ) : (
                    <></>
                  )}
                </Tooltip>
              </Space>
            </div>
            <div className="resumeResultsCard-Icons">
              <Space onClick={(ev) => handleSelectedQ(ev, index)}>
                {toSelect == 2 ? (
                  <>
                    <Tooltip
                      placement="bottom"
                      title={"Added to QSET"}
                      color="white"
                      overlayInnerStyle={{
                        color: "#000",
                      }}
                    >
                      <img
                        src={CheckIcon}
                        alt="AI"
                        width="14"
                        height="14"
                        className="image"
                        onClick={handleAIIcon}
                      />
                    </Tooltip>
                  </>
                ) : toSelect == 1 ? (
                  <>
                    <Tooltip
                      placement="bottom"
                      title={"Added to QSET"}
                      color="white"
                      overlayInnerStyle={{
                        color: "#000",
                      }}
                    >
                      <CheckSquareOutlined />
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <Tooltip
                      placement="bottom"
                      title={"Add to QSET"}
                      color="white"
                      overlayInnerStyle={{
                        color: "#000",
                      }}
                    >
                      <PlusOutlined style={{ cursor: "pointer" }} />
                    </Tooltip>
                  </>
                )}
              </Space>
            </div>
          </>
        ) : (
          <>
            <div className="resumeResultsCard-Icons">
              <Space onClick={(ev) => localDelinkHandler(ev, index)}>
                <Tooltip
                  placement="bottom"
                  title={"Remove"}
                  color="white"
                  overlayInnerStyle={{
                    color: "#000",
                  }}
                >
                  {toDelink ? (
                    <DisconnectOutlined style={{ cursor: "pointer" }} />
                  ) : (
                    <></>
                  )}
                </Tooltip>
              </Space>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
